import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { useSite } from "@/lib/site";

export default function Hero({ onBookCall }) {
  const { loadPageMeta, site } = useSite();
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    loadPageMeta("home").then(setMeta);
  }, [loadPageMeta]);

  const headline = meta?.hero_headline || "Build AI-Powered Digital Products Faster.";
  const subheadline = meta?.hero_subheadline || "AI Solutions · Enterprise Software · Telecom Platforms · Dedicated Engineering Teams.";
  const overline = meta?.hero_overline || "AI-first engineering · est. 2011";
  const heroImg = site?.brand?.banner || meta?.hero_image || "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=800";
  const ctaPrimary = meta?.hero_cta_primary || "Book Strategy Call";
  const ctaSecondary = meta?.hero_cta_secondary || "Explore Case Studies";

  return (
    <section data-testid="hero-section" className="relative flex items-center min-h-[calc(100dvh-64px)] py-5 md:py-15 border-b border-border overflow-hidden">
      <div className="w-full max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-8 md:gap-10 items-center">
        <div className="md:col-span-7 lg:col-span-6">
          <p data-fade className="text-[11px] font-mono uppercase tracking-[0.22em] text-muted-foreground">
            {overline}
          </p>
          <h1
            data-testid="hero-headline"
            className="font-display font-extrabold text-3xl sm:text-4xl md:text-[48px]/[1.15] mt-3 tracking-[-0.02em] text-foreground max-w-3xl"
          >
            {headline}
          </h1>
          <p
            data-testid="hero-subheadline"
            data-fade
            style={{ animationDelay: "0.14s" }}
            className="mt-4 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed"
          >
            {subheadline}
          </p>
          <div data-fade style={{ animationDelay: "0.22s" }} className="mt-6 flex flex-wrap items-center gap-3">
            <button
              data-testid="hero-book-call-btn"
              onClick={onBookCall}
              className="btn-cta bg-primary hover:bg-primary/90 text-primary-foreground px-6 py-3 text-sm font-semibold rounded-md inline-flex items-center gap-2 shadow-sm"
            >
              {ctaPrimary}
              <ArrowRight className="w-4 h-4" aria-hidden />
            </button>
{/*             <Link
              to="/case-studies"
              data-testid="hero-case-studies-btn"
              className="text-foreground border border-border hover:border-foreground/40 px-6 py-3 text-sm font-semibold rounded-md inline-flex items-center gap-2 transition-colors"
            >
              <PlayCircle className="w-4 h-4" aria-hidden />
              {ctaSecondary}
            </Link> */}
          </div>

          {/* <HeroStats /> */}
        </div>

        <div className="md:col-span-5 lg:col-span-6 relative">
          <div className="aspect-[4/5] md:aspect-square max-h-[65vh] w-full overflow-hidden bg-muted rounded-lg card-shadow">
            <img
              src={heroImg}
              alt="Enterprise engineering at Miaki"
              loading="eager"
              fetchPriority="high"
              width="800"
              height="800"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

// function HeroStats() {
//   const [stats, setStats] = useState([]);
//   useEffect(() => {
//     api.get("/statistics").then((r) => setStats(r.data.slice(0, 4))).catch(() => setStats([]));
//   }, []);
//   if (!stats.length) return null;
//   return (
//     <dl className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl" data-testid="hero-stats">
//       {stats.map((s, i) => (
//         <div key={i}>
//           <dt className="font-display font-extrabold text-2xl text-foreground">{s.value}</dt>
//           <dd className="text-xs text-muted-foreground mt-1 leading-snug">{s.label}</dd>
//         </div>
//       ))}
//     </dl>
//   );
// }
